import { createRouter, createWebHistory } from "vue-router";
import LoginView from "@/view/login.vue";
import HomeView from "@/view/Home.vue";
import { PublicStore } from "@/tools/pinia/store";

const routes = [
  { path: "/", redirect: "/login" },
  { path: "/login", component: LoginView },
  { path: "/home", component: HomeView, meta: { requiresAuth: true } },
  { path: "/:catchAll(.*)", redirect: "/login" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫：未登录则跳回登录页
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const publicData = PublicStore();
    if (!publicData.AccessToken) {
      next("/login");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
